if($('.js-step').length) {
// Used to add min height to element which matches the width. (creates a square when dynamic content is in use)
        $(window).on('load resize', function () {
                var $stepHeight = $('.js-step').height();
                var $sliderHeight = $('.num').height();

                if ($(window).width() >= 1200) {
                        var $totalHeight = $sliderHeight - $stepHeight;
                        $('.js-match-height').css({'height': $totalHeight + 'px', 'margin-bottom': '15px'});
                        $('.js-match-height-img').css('height', $totalHeight + 'px');
                } else {
                        var $totalHeight = $sliderHeight + $stepHeight;
                        $('.js-match-height').css({'height': $totalHeight + 'px', 'margin-bottom': '15px'});
                        $('.js-match-height-img').css('height', $totalHeight + 'px');
                }
        }).resize();
}else{

}
